export enum EnumCorridorColor {
  GREEN = 'GREEN',
  LIGHTGREEN = 'LIGHTGREEN',
  ORANGE = 'ORANGE',
  RED = 'RED',
  BLACK = 'BLACK',
  BELOW_BLACK = 'BELOW_BLACK',
  NONE = 'NONE',
  GRAY = 'GRAY',


}

export function getColorFromString(colorString: string): EnumCorridorColor | null {
    for (const color in EnumCorridorColor) {
        if (Object.prototype.hasOwnProperty.call(EnumCorridorColor, color)) {
            if (EnumCorridorColor[color as keyof typeof EnumCorridorColor] === colorString) {
                return color as EnumCorridorColor;
            }
        }
    }
    return null;
}
